/**
 * OR gclid Book Now backup (2026-09-14)
 * Stores landing-page gclid first-party and appends ?gclid= to NewBook Book Now
 * links so Conversion Linker on bookingsus.newbook.cloud can mint _gcl_aw even if
 * cross-domain _gl decoration misses. Does not replace Conversion Linker.
 * Same-tab only. No PII.
 */
(function () {
  var STORAGE_KEY = 'or_gclid';
  var COOKIE_KEY = 'or_gclid';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var NEWBOOK_HOST = 'bookingsus.newbook.cloud';

  function now() { return Date.now(); }

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return '';
      var o = JSON.parse(raw);
      if (!o || !o.gclid || !o.exp || o.exp < now()) return '';
      return String(o.gclid);
    } catch (e) {
      return '';
    }
  }

  function writeStored(gclid) {
    if (!gclid) return;
    var payload = JSON.stringify({ gclid: String(gclid), exp: now() + TTL_MS });
    try { localStorage.setItem(STORAGE_KEY, payload); } catch (e) {}
    try {
      var maxAge = Math.floor(TTL_MS / 1000);
      document.cookie = COOKIE_KEY + '=' + encodeURIComponent(String(gclid)) +
        '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    } catch (e) {}
  }

  function fromQuery() {
    try {
      var p = new URLSearchParams(window.location.search);
      return p.get('gclid') || p.get('gbraid') || p.get('wbraid') || '';
    } catch (e) {
      return '';
    }
  }

  function fromGclAw() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)_gcl_aw=([^;]+)/);
      if (!m) return '';
      var parts = decodeURIComponent(m[1]).split('.');
      if (parts.length < 3) return '';
      return parts.slice(2).join('.');
    } catch (e) {
      return '';
    }
  }

  function fromOrCookie() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)or_gclid=([^;]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function currentGclid() {
    var q = fromQuery();
    if (q) { writeStored(q); return q; }
    var aw = fromGclAw();
    if (aw) { writeStored(aw); return aw; }
    return readStored() || fromOrCookie() || '';
  }

  function isNewbookLink(a) {
    if (!a || !a.getAttribute) return false;
    var href = a.getAttribute('href') || '';
    return href.indexOf(NEWBOOK_HOST) !== -1;
  }

  function decorateHref(href, gclid) {
    if (!href || !gclid) return href;
    try {
      var u = new URL(href, window.location.origin);
      if (u.hostname.indexOf('newbook.cloud') === -1) return href;
      if (u.searchParams.get('gclid')) return href;
      u.searchParams.set('gclid', gclid);
      return u.toString();
    } catch (e) {
      if (/[?&]gclid=/.test(href)) return href;
      return href + (href.indexOf('?') >= 0 ? '&' : '?') + 'gclid=' + encodeURIComponent(gclid);
    }
  }

  function decorateAll() {
    var gclid = currentGclid();
    if (!gclid) return;
    var links = document.querySelectorAll('a[href*="newbook.cloud"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var next = decorateHref(a.getAttribute('href'), gclid);
      if (next && next !== a.getAttribute('href')) a.setAttribute('href', next);
    }
  }

  function onClick(e) {
    var t = e.target;
    while (t && t.tagName !== 'A') t = t.parentElement;
    if (!isNewbookLink(t)) return;
    var gclid = currentGclid();
    if (!gclid) return;
    var next = decorateHref(t.getAttribute('href'), gclid);
    if (next && next !== t.getAttribute('href')) t.setAttribute('href', next);
  }

  // Capture landing gclid immediately.
  currentGclid();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateAll);
  } else {
    decorateAll();
  }
  document.addEventListener('click', onClick, true);
  // Late-rendered CTAs (sections, drawers).
  setTimeout(decorateAll, 1000);
  setTimeout(decorateAll, 3000);
})();
